import { ImProfile } from "react-icons/im";
export const PublicTicketData = [
  {
    id: "1",
    name: "تیکت جدید",
    path: "/dashboard/ticket/AddTicket",
    icon: <ImProfile size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "لیست تیکت ها",
    path: "/dashboard/ticket/ticketsList",
    icon: <ImProfile size={25} />,
    color: "#f1416c",
    type: "menu",
  },
];
